module.exports = __webpack_public_path__ + "static/img/ruby-icon.d80f423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruby-icon.png
// module id = YSro
// module chunks = 0